import axios from "axios"
import { Base_Api_Endpoints } from "../configuration/Enums/API_Endpoints"


export const Auth_APIs={
    Validate_Token:async (payload)=>{
        return await  axios.post(`${Base_Api_Endpoints.SpringBoot_API_Endpoint}/api/v2/auth/login`,payload)
    },
    Get_User_Info:async (token)=>{
        return await axios.get(`${Base_Api_Endpoints.SpringBoot_API_Endpoint}/api/v3/user/info`,{headers:{Authorization:`Bearer ${token}`}});
    }
}